import React from 'react';
import { SharedEcgScreen } from 'screens';
import { RoutePath } from 'types/enums';

const PUBLIC_ROUTES = [{ path: RoutePath.SHARED_ECG, element: <SharedEcgScreen /> }];

export { PUBLIC_ROUTES };
